import { inject } from '@angular/core'
import type { CanMatchFn } from '@angular/router'
import { take } from 'rxjs/operators'

import { AuthStore } from '@app/modules/auth/store/auth.store'

export const canMatchLoggedIn: CanMatchFn = () => {
  const authStore = inject(AuthStore)
  return authStore.loggedIn$.pipe(take(1))
}
